import React from 'react';
import { FaShieldAlt, FaPhone, FaEnvelope } from 'react-icons/fa';

const Grievance = () => {
  return (
    <div className="py-16 bg-gradient-to-b from-orange-50 to-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">Grievance <span className="text-orange-500">Redressal</span></h1>
          <div className="w-20 h-1 bg-orange-500 mx-auto"></div>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8">
          <FaShieldAlt className="text-5xl text-orange-500 mx-auto mb-6" />
          <p className="text-gray-600 text-center mb-6">If you have any complaint or concern, please reach out to our Grievance Officer.</p>
          
          <div className="space-y-4">
            <div className="flex items-center gap-3 p-4 bg-orange-50 rounded-xl">
              <FaPhone className="text-orange-500" />
              <span className="text-gray-700">+91 9709799555</span>
            </div>
            <div className="flex items-center gap-3 p-4 bg-orange-50 rounded-xl">
              <FaEnvelope className="text-orange-500" />
              <span className="text-gray-700">info@brframes.com</span>
            </div>
          </div>

          <p className="text-sm text-gray-500 mt-6">We aim to resolve all grievances within 7 working days.</p>
        </div>
      </div>
    </div>
  );
};

export default Grievance;